module.exports = __webpack_public_path__ + "img/Groupe 522.98afa781.svg";